<script setup lang="ts">
interface Props {
  label?: string
  disabled?: boolean
  diameter?: number
  dark?: boolean
  iconClass?: string
  size?: "sm" | "lg"
}

const props = withDefaults(defineProps<Props>(), {
  diameter: 24,
  size: "lg",
})

const emit = defineEmits(["click"])

const model = defineModel({
  default: false,
})

function toggleCheckbox() {
  if (!props.disabled) {
    const newValue = !model.value
    model.value = newValue
    emit("click", newValue)
  }
}

const hover = ref(false)
const mouseDown = ref(false)
</script>

<template>
  <div class="flex cursor-pointer items-center" @click="toggleCheckbox">
    <div>
      <template v-if="model">
        <UIcon
          name="check"
          size="xs"
          class="rounded-full bg-green-60"
          :class="{
            'p-2': size === 'sm',
            'p-3': size === 'lg',
          }"
        />
      </template>
      <template v-else>
        <div
          class="flex items-center justify-center rounded-full border-2 border-white"
          :class="{
            'size-8': size === 'sm',
            'size-10': size === 'lg',
            'border-[3px]': mouseDown,
            'border-2': !mouseDown,
            'opacity-100': hover,
            'opacity-70': !hover,
          }"
          @mouseenter="
            () => {
              mouseDown = false
              hover = true
            }
          "
          @mouseleave="
            () => {
              mouseDown = false
              hover = false
            }
          "
          @mousedown="
            () => {
              mouseDown = true
              hover = true
            }
          "
          @mouseup="
            () => {
              mouseDown = false
              hover = false
            }
          "
        >
          <UIcon
            name="check"
            :class="{ hidden: !hover }"
            size="xxs"
            :icon-class="iconClass ? iconClass : undefined"
          />
        </div>
      </template>
    </div>
    <label
      v-if="label"
      class="ml-3"
      v-text="label"
    />
  </div>
</template>
